'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './list-edit.routes';

export class PiperListEditComponent {
  constructor(Auth, PiperListService, PiperGuestService, $stateParams, $state, dialogs, $location) {
    'ngInject';

    this.PiperListService = PiperListService;
    this.PiperGuestService = PiperGuestService;

    this.$state = $state;
    this.$location = $location;
    this.dialogs = dialogs;

    this.guestId = $stateParams.id;
    this.type = $stateParams.type;

    this.isNewGuest = true;
    this.title = "Create " + this.type + " List Entry";

    this.guests = [];

    this.PiperGuestService.getByHost({
        hostId: Auth.getCurrentUserSync()._id
      }, data => {
        this.guests = data.map(guest => {
          if (guest.isBusiness) {
            guest.label = guest.business + " (Business)";
          } else {
            guest.label = guest.firstName + " " + guest.lastName;
          }
          return guest;
        });
    });

    this.initalState = (this.type == 'permanent') ? "toBeApproved": "planned";

    this.guest = {
      host: Auth.getCurrentUserSync()._id,
      type: this.type,
      state: this.initalState,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    if (this.guestId) {
      this.PiperListService.get({id: this.guestId}, data => {
        this.guest = data;
        this.isNewGuest = false;
        this.title = "Edit " + this.type + " List Entry";
      }, err => {
        console.log('Could not load piper list from server');
      })
    }
  }

  checkExpectedDate(data) {
    if (new Date(data) < new Date()) {
      return "The expected arrival date must not be in the past";
    }
  }

  create(form) {
    var that = this;

    if (!this.guest.guest) {
      this.dialogs.error("Select a guest", "You must a guest which you want to add to your " + this.type + " list");
      return;
    }

    if (this.guest.type == 'temporary') {
      if (!this.guest.expectedArrival) {
        this.dialogs.error("Expected Arrival Time", "You must enter an expected arrival time for your guest");
        return;
      }
    }

    var onSuccess = () => {
      that.submitted = false;

      //TODO: Send cache clear to Gate of Dawn

      var actionString = (that.guestId) ? "changed" : "created";
      var dlg = that.dialogs.notify("Success", "Your guest list has been "+actionString+" successfully");
      dlg.result.then(() => {
        that.$location.path("/piper/"+that.type+"/list");
      });
    };

    var onError = err => {
      that.sendFailure = true;
    };

    if (this.guestId) {
      this.PiperListService.update({id: this.guestId}, this.guest, onSuccess, onError);
    } else {
      this.PiperListService.save(this.guest, onSuccess, onError);
    }
  }
}

export default angular.module('conduuApp.piperListEdit', [uiRouter])
  .config(routes)
  .component('piperListEdit', {
    template: require('./list-edit.html'),
    controller: PiperListEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/piper/list/edit/list-edit.component.js